{
	"eur": {
		"symbol": "€",
		"html_symbol": "&#8364;",
		"symbol_position": "before",
		"code": "EUR",
		"name": "currency_eur",
		"decimals": 2,
		"multiplier": 100,
		"min_instant_payout_value": 100,
		"max_instant_payout_value": 999900,
		"min_stripe_amount": 50,
		"max_stripe_amount": 2000000,
		"min_free_delivery_amount": 1000,
		"min_free_shipping_amount": 300,
		"min_hide_prices_amount": 100,
		"max_free_weekly_cash_amount": 300000,
		"sms_fee": 10,
		"tap_to_pay_fee": 10,
		"fixed_fee": 20,
		"eur_conversion_rate": 1,
		"countries": ["IT", "ES", "FR", "DE"],
		"tiers": {
			"custom": null,
			"base": 0,
			"small": 500000,
			"big": 2000000
		},
		"prices": {
			"plans": {
				"basic": {
					"yearMonth": 29,
					"month": 39
				},
				"pro": {
					"yearMonth": 49,
					"month": 59
				},
				"allinone": {
					"yearMonth": 99,
					"month": 119
				},
				"year_save": 240
			},
			"load_menu": {
				"amount": 69,
				"full_price": 99
			},
			"v3": {
				"amount": 349
			},
			"v3mix": {
				"amount": 699
			},
			"d3mini": {
				"amount": 549
			},
			"d3family": {
				"amount": 1499
			},
			"qromotabletd3": {
				"amount": 1099
			},
			"qromotablethonor": {
				"amount": 249
			},
			"qromopos700": {
				"amount": 399
			},
			"qromopos": {
				"amount": 199,
				"amount_full": 250
			},
			"qromobundle": {
				"amount": 1699,
				"amount_full": 3285
			},
			"qromoposwisepad": {
				"amount": 60
			},
			"epsonprinter": {
				"amount": 799,
				"amount_full": 899
			},
			"qromoprinter": {
				"amount": 249
			},
			"shipping_low": {
				"amount": 10
			},
			"shipping_high": {
				"amount": 20
			}
		}
	},
	"usd": {
		"symbol": "$",
		"html_symbol": "&#36;",
		"symbol_position": "before",
		"code": "USD",
		"name": "currency_usd",
		"decimals": 2,
		"multiplier": 100,
		"min_instant_payout_value": 100,
		"max_instant_payout_value": 999900,
		"min_stripe_amount": 50,
		"max_stripe_amount": 2000000,
		"min_free_delivery_amount": 1000,
		"min_free_shipping_amount": 330,
		"min_hide_prices_amount": 100,
		"max_free_weekly_cash_amount": 330000,
		"sms_fee": 11,
		"tap_to_pay_fee": 11,
		"fixed_fee": 22,
		"eur_conversion_rate": 1.1,
		"countries": ["US"],
		"tiers": {
			"custom": null,
			"base": 0,
			"small": 550000,
			"big": 2200000
		},
		"prices": {
			"plans": {
				"basic": {
					"yearMonth": 32,
					"month": 43
				},
				"pro": {
					"yearMonth": 54,
					"month": 65
				},
				"allinone": {
					"yearMonth": 109,
					"month": 131
				},
				"year_save": 264
			},
			"load_menu": {
				"amount": 75.90,
				"full_price": 108.90
			},
			"v3": {
				"amount": 383.90
			},
			"v3mix": {
				"amount": 768.90
			},
			"d3mini": {
				"amount": 603.90
			},
			"d3family": {
				"amount": 1648.90
			},
			"qromotabletd3": {
				"amount": 1208.90
			},
			"qromotablethonor": {
				"amount": 274.90
			},
			"qromopos700": {
				"amount": 438.90
			},
			"qromopos": {
				"amount": 218.90,
				"amount_full": 275
			},
			"qromobundle": {
				"amount": 1868.90,
				"amount_full": 3613.50
			},
			"qromoposwisepad": {
				"amount": 66
			},
			"epsonprinter": {
				"amount": 879.90,
				"amount_full": 988.90
			},
			"qromoprinter": {
				"amount": 273.90
			},
			"shipping_low": {
				"amount": 11
			},
			"shipping_high": {
				"amount": 22
			}
		}
	},
	"gbp": {
		"symbol": "£",
		"html_symbol": "&#163;",
		"symbol_position": "before",
		"code": "GBP",
		"name": "currency_gbp",
		"decimals": 2,
		"multiplier": 100,
		"min_instant_payout_value": 100,
		"max_instant_payout_value": 999900,
		"min_stripe_amount": 30,
		"max_stripe_amount": 1600000,
		"min_free_delivery_amount": 800,
		"min_free_shipping_amount": 240,
		"min_hide_prices_amount": 100,
		"max_free_weekly_cash_amount": 240000,
		"sms_fee": 8,
		"tap_to_pay_fee": 8,
		"fixed_fee": 16,
		"eur_conversion_rate": 0.8,
		"countries": ["GB"],
		"tiers": {
			"custom": null,
			"base": 0,
			"small": 400000,
			"big": 1600000
		},
		"prices": {
			"plans": {
				"basic": {
					"yearMonth": 24,
					"month": 32
				},
				"pro": {
					"yearMonth": 39,
					"month": 47
				},
				"allinone": {
					"yearMonth": 79,
					"month": 95
				},
				"year_save": 192
			},
			"load_menu": {
				"amount": 55.20,
				"full_price": 79
			},
			"v3": {
				"amount": 279.20
			},
			"v3mix": {
				"amount": 559.20
			},
			"d3mini": {
				"amount": 439.20
			},
			"d3family": {
				"amount": 1199.20
			},
			"qromotabletd3": {
				"amount": 879.20
			},
			"qromotablethonor": {
				"amount": 199.20
			},
			"qromopos700": {
				"amount": 319.20
			},
			"qromopos": {
				"amount": 159.20,
				"amount_full": 200
			},
			"qromobundle": {
				"amount": 1359.20,
				"amount_full": 2628
			},
			"qromoposwisepad": {
				"amount": 48
			},
			"epsonprinter": {
				"amount": 639.20,
				"amount_full": 719.20
			},
			"qromoprinter": {
				"amount": 199.20
			},
			"shipping_low": {
				"amount": 8
			},
			"shipping_high": {
				"amount": 16
			}
		}
	},
	"aed": {
		"symbol": "AED",
		"html_symbol": "AED",
		"symbol_position": "before",
		"code": "AED",
		"name": "currency_aed",
		"decimals": 2,
		"multiplier": 100,
		"min_instant_payout_value": 400,
		"max_instant_payout_value": 3999900,
		"min_stripe_amount": 200,
		"max_stripe_amount": 8000000,
		"min_free_delivery_amount": 4000,
		"min_free_shipping_amount": 1200,
		"min_hide_prices_amount": 400,
		"max_free_weekly_cash_amount": 1200000,
		"sms_fee": 40,
		"tap_to_pay_fee": 40,
		"fixed_fee": 80,
		"eur_conversion_rate": 4,
		"countries": ["AE"],
		"tiers": {
			"custom": null,
			"base": 0,
			"small": 2000000,
			"big": 8000000
		},
		"prices": {
			"plans": {
				"basic": {
					"yearMonth": 116,
					"month": 156
				},
				"pro": {
					"yearMonth": 196,
					"month": 236
				},
				"allinone": {
					"yearMonth": 396,
					"month": 476
				},
				"year_save": 960
			},
			"load_menu": {
				"amount": 276,
				"full_price": 396
			},
			"v3": {
				"amount": 1396
			},
			"v3mix": {
				"amount": 2796
			},
			"d3mini": {
				"amount": 2196
			},
			"d3family": {
				"amount": 5996
			},
			"qromotabletd3": {
				"amount": 4396
			},
			"qromotablethonor": {
				"amount": 996
			},
			"qromopos700": {
				"amount": 1596
			},
			"qromopos": {
				"amount": 796,
				"amount_full": 1000
			},
			"qromobundle": {
				"amount": 6796,
				"amount_full": 13140
			},
			"qromoposwisepad": {
				"amount": 240
			},
			"epsonprinter": {
				"amount": 3196,
				"amount_full": 3596
			},
			"qromoprinter": {
				"amount": 996
			},
			"shipping_low": {
				"amount": 40
			},
			"shipping_high": {
				"amount": 80
			}
		}
	},
	"chf": {
		"symbol": "CHF",
		"html_symbol": "CHF",
		"symbol_position": "after",
		"code": "CHF",
		"name": "currency_chf",
		"decimals": 2,
		"multiplier": 100,
		"min_instant_payout_value": 100,
		"max_instant_payout_value": 999900,
		"min_stripe_amount": 50,
		"max_stripe_amount": 2000000,
		"min_free_delivery_amount": 800,
		"min_free_shipping_amount": 270,
		"min_hide_prices_amount": 100,
		"max_free_weekly_cash_amount": 270000,
		"sms_fee": 9,
		"tap_to_pay_fee": 9,
		"fixed_fee": 18,
		"eur_conversion_rate": 0.9,
		"countries": ["CH"],
		"tiers": {
			"custom": null,
			"base": 0,
			"small": 450000,
			"big": 1800000
		},
		"prices": {
			"plans": {
				"basic": {
					"yearMonth": 27,
					"month": 35
				},
				"pro": {
					"yearMonth": 44,
					"month": 53
				},
				"allinone": {
					"yearMonth": 89,
					"month": 107
				},
				"year_save": 216
			},
			"load_menu": {
				"amount": 62.10,
				"full_price": 89.10
			},
			"v3": {
				"amount": 314.10
			},
			"v3mix": {
				"amount": 629.10
			},
			"d3mini": {
				"amount": 494.10
			},
			"d3family": {
				"amount": 1349.10
			},
			"qromotabletd3": {
				"amount": 989.10
			},
			"qromotablethonor": {
				"amount": 224.10
			},
			"qromopos700": {
				"amount": 359.10
			},
			"qromopos": {
				"amount": 179.10,
				"amount_full": 190
			},
			"qromobundle": {
				"amount": 1529.10,
				"amount_full": 2956.50
			},
			"qromoposwisepad": {
				"amount": 54
			},
			"epsonprinter": {
				"amount": 719.10,
				"amount_full": 809.10
			},
			"qromoprinter": {
				"amount": 224.10
			},
			"shipping_low": {
				"amount": 9
			},
			"shipping_high": {
				"amount": 18
			}
		}
	}
}